import moment from "moment";
import {url} from '../utilities';
import Spinner from "../spinner";
import * as $ from "jquery";

const dt_polish = require('../dt.polish.json');

export const logs = async () => {

    $('#archivedLogs').DataTable({
        filters: {
            columns: [
                {
                    index: 1,
                    title: 'Rodzaj'
                }
            ]
        }
    })

    if($("#changeLogsDate").length > 0) {
        let dateFrom = $("#changeLogsDate input[name='from']").val();
        let dateTo = $("#changeLogsDate input[name='to']").val();
        let type = $("#changeLogsDate input[name='type']").val();

        dateFrom = moment(dateFrom, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm');
        dateTo = moment(dateTo, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm');

        let query = new URLSearchParams({
            from: dateFrom,
            to: dateTo,
            type
        });

        let spinner = new Spinner();
        let columns = [
            {
                title: 'Data',
                data: 'date'
            },
            {
                title: 'Poziom',
                data: 'level',
                render: data => {
                    return `<span style="color: ${levelColor(data)}">${data}</span>`
                }
            },
            {
                title: 'Użytkownik',
                data: 'user'
            },
            {
                title: 'IP',
                data: 'ip'
            },
            type !== 'requests' ? {title: 'Adres', data: 'url_path'} : null,
            {
                title: 'Wiadomość',
                data: 'message'
            },
            {
                title: 'Inne dane',
                data: 'context',
                className: 'none',
                render: data => {
                    return `<code>${JSON.stringify(data, null, 2)}</code>`;
                }
            }
        ].filter(el => el !== null);

        let table = $("#logsTable");
        table.DataTable({
            stateSave: false,
            deferRender: true,
            order: [0, 'desc'],
            resize: true,
            ajax: url(`api/admin/logs?${query.toString()}`),
            columns,
            responsive: {
                details: {
                    display: $.fn.dataTable.Responsive.display.childRow,
                    type: 'inline'
                }
            },
            language: {
                ...dt_polish
            },
            pageLength: 50,
            filters: {
                columns: [
                    {index: 1, title: 'Poziom'}
                ]
            },
            initComplete: () => {
                spinner.destroy();
            }
        });
    }
}

const levelColor = (level) => {
    switch (level) {
        case 'error':
            return 'red';
        case 'warning':
            return 'yellow';
    }

    return 'black';
}
